import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { forEach } from '@beef/utils';
import { StylesProjection } from "./StylesProjection";

// eslint-disable-next-line prettier/prettier
export var StylesDecorator = /*#__PURE__*/function (_StylesProjection) {
  _inherits(StylesDecorator, _StylesProjection);
  var _super = _createSuper(StylesDecorator);
  function StylesDecorator(value, params, childUtils) {
    var _this;
    _classCallCheck(this, StylesDecorator);
    _this = _super.call(this, value, params);
    _this.value = value;
    _this.params = params;
    _this.childUtils = childUtils;
    return _this;
  }

  /** Custom functions */
  _createClass(StylesDecorator, [{
    key: "hasChild",
    value: function hasChild(styleId) {
      return styleId in this.value;
    }
  }, {
    key: "pushChild",
    value: function pushChild(styleId) {
      this.value[styleId] = this.childUtils.create(undefined, {
        styleId: styleId
      });
    }
  }, {
    key: "accept",
    value: function accept(visitor) {
      forEach(this.value, function (style, styleId) {
        return visitor.visit(style, {
          styleId: styleId
        });
      });
    }
  }]);
  return StylesDecorator;
}(StylesProjection);